export const pickTopmostCanvasHit = ({ hits = [] } = {}) => {
  if (!hits.length) return null;
  const foreground = hits.filter((hit) => !hit.isBackground);
  const candidates = foreground.length ? foreground : hits;
  let best = null;
  let bestScore = -Infinity;
  candidates.forEach((hit) => {
    const paint = Number(hit.paintIndex) || 0;
    const z = Number(hit.zIndex) || 0;
    const area = Number(hit.area) || 0;
    const areaTie = Math.round((1 / (1 + area)) * 1000);
    const score = paint * 1e9 + z * 1e6 + areaTie;
    if (score >= bestScore) {
      best = hit;
      bestScore = score;
    }
  });
  return best;
};
